import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { InventarioService } from '../inventario.service';

/*  BEÁLLÍTÁSOK – raktárak, egyedi mezők (a régi „Mezőszerkesztő”: csoportonként szöveg / szám / lista,
 *  csoport nélkül minden cikkre), és – a könyvelőirodának – az ügyfél-hozzáférés. */
@Component({
  selector: 'app-inventario-beallitasok',
  templateUrl: './beallitasok.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../inventario-shared.scss'],
})
export class InventarioBeallitasokComponent implements OnInit, OnDestroy {
  raktarak: any[] = [];
  mezok: any[] = [];
  hozzaferes: any[] | null = null;
  raktarSzerk: any = null;
  mezoSzerk: any = null;
  ujFelhasznalo = '';
  private sub?: Subscription;
  constructor(public inv: InventarioService, private toast: ToastController) {}
  get u() { return this.inv.aktiv.ugyfelId; }
  get ir() { return this.inv.ir; }
  async ngOnInit() { await this.inv.init(); this.sub = this.inv.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }
  async frissit() {
    if (!this.u) return;
    try { this.raktarak = await this.inv.get(`/raktarak/${this.u}`); this.mezok = await this.inv.get(`/mezok/${this.u}`); } catch { /* */ }
    try { this.hozzaferes = await this.inv.get(`/hozzaferes/${this.u}`); } catch { this.hozzaferes = null; }
  }
  raktarNyit(r: any) { this.raktarSzerk = r ? { ...r, aktiv: !!+r.aktiv, alapertelmezett: !!+r.alapertelmezett } : { id: null, nev: '', kod: '', aktiv: true, alapertelmezett: false }; }
  async raktarMent() {
    try { await this.inv.post(`/raktar/${this.u}`, this.raktarSzerk); this.raktarSzerk = null; await this.frissit(); this.ok('Mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  mezoUj() { this.mezoSzerk = { id: null, csoport: '', nev: '', tipus: 'szoveg', opciokSzoveg: '' }; }
  mezoNyit(m: any) { this.mezoSzerk = { ...m, opciokSzoveg: (m.opciok || []).join('\n') }; }
  async mezoMent() {
    const m = this.mezoSzerk;
    try { await this.inv.post(`/mezo/${this.u}`, { ...m, opciok: String(m.opciokSzoveg || '').split('\n').map((x: string) => x.trim()).filter(Boolean) }); this.mezoSzerk = null; await this.frissit(); this.ok('Mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  async mezoTorol(m: any) { try { await this.inv.del(`/mezo/${this.u}/${m.id}`); this.mezoSzerk = null; await this.frissit(); } catch { /* */ } }
  async hozzaferesAd() {
    try { await this.inv.post(`/hozzaferes/${this.u}`, { felhasznalo: this.ujFelhasznalo }); this.ujFelhasznalo = ''; this.ok('Hozzáférés megadva.'); await this.frissit(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2400, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 4000, color: 'danger' })).present(); }
}
